import React, {
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from "react";

import SessionTransitionOverlay from "@is/components/SessionTransitionOverlay";

type SessionTransitionContextValue = {
  startTransition: () => void;
};

export const SessionTransitionContext =
  React.createContext<SessionTransitionContextValue | null>(null);

export const SessionTransitionProvider = ({ children }: PropsWithChildren) => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  const startTransition = useCallback(() => setIsTransitioning(true), []);

  const value = useMemo(() => ({ startTransition }), [startTransition]);

  return (
    <SessionTransitionContext.Provider value={value}>
      {children}
      {isTransitioning && <SessionTransitionOverlay />}
    </SessionTransitionContext.Provider>
  );
};
